export default "__VITE_ASSET__5vcK_yyw__"